<template>
  <h3 class="title please_wait_txt">
    {{ getTranslations.home_loader_please_wait }}
    <span id="wait-custom">{{ animatedDotText }}</span>
  </h3>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'TextLoader',
  data () {
    return {
      animatedDotText: '',
      intervalConfiguration: {id: null, delay: 400}
    }
  },
  mounted () {
    this.intervalConfiguration.id = setInterval(() => {
      if (this.animatedDotText.length > 2) {
        this.animatedDotText = ''
      } else {
        this.animatedDotText += '.'
      }
    }, this.intervalConfiguration.delay)
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ])
  },
  beforeDestroy () {
    clearInterval(this.intervalConfiguration.id)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/loader/TextLoader.vue